// extracted by mini-css-extract-plugin
export default {"container":"styles__container___khLN2","children":"styles__children___QWOPv"};